import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as Sentry from "@sentry/react";


const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
const appEnv = import.meta.env.VITE_APP_ENV;
if (sentryDsn && appEnv) {
	Sentry.init({
		dsn: sentryDsn,
		environment: appEnv
	})
}

import "./index.css";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find root element");
createRoot(rootElement).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
